import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
        <h1 className="text-2xl font-bold text-gray-800">Privacy Policy</h1>
        <p className="text-gray-600 mt-2">
        We respect user privacy and ensure data is used only for volunteer
        management. No personal data is shared with third parties, and users can
        request data removal at any time.
        </p>

        <Link
          to="/"
          className="inline-block mt-4 px-6 py-2 text-white bg-green-600 rounded-lg text-lg hover:bg-green-700"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
